import tenantConstants from '@constants';
import tenantPayloads from '@payloads';
import tenantTransformers from '@transformers';
import tenantUtils from '@utils';
import { getAppSource } from '../../../store/parentApi';
import { convertQueryObjToString } from '../../../utility/urlQuery';

const postNewListingEndpoints = {
  postNewListing: {
    query: (queryObj) => {
      const source = getAppSource();
      return `/api/listings/new?${convertQueryObjToString(queryObj)}&source=${source}`;
    },
  },
  getAmenities: {
    query: (purposeId) => {
      return {
        url: `/api/amenities${purposeId ? `?purpose_id=${purposeId}` : ''}`,
      };
    },
    transformer: (response) => tenantTransformers.amenitiesDataMapper(response?.amenities),
  },

  getQualityCriteria: {
    query: () => {
      return {
        url: `/api/listings/listing_score_metrics`,
      };
    },
    transformer: (response) => {
      return response?.score_metrics;
    },
  },

  getAutoGeneratedListingContent: {
    query: (body) =>
      `/api/listings/${body?.listingId}/generate_content?${convertQueryObjToString(tenantPayloads.autoGeneratedListingContentPayload(body))}`,
  },
  getPriceCheck: {
    query: ({ values }) => {
      const areaUnitSlug = tenantData.areaUnitList.find((e) => e.id === values.area.unit)?.slug;
      const payload = {
        location_id: values.location_select?.location.location_id,
        type_id: values.property_type,
        purpose_id: values.purpose,
        area: (values.area.value * tenantData.areaMapings[areaUnitSlug]['square_feet']).toFixed(0),
        price: values?.monthly_rent.value ? values?.monthly_rent?.value : values.price.value,
      };
      return { url: `/api/listings/price_check`, body: payload };
    },
  },
  getListingDetail: {
    query: ({ listingId }) => {
      return {
        url: `/api/listings/${listingId}/edit`,
      };
    },
    transformer: (response) => {
      const listing = response?.listing;
      const residenceTypes = response?.residence_types;
      const isOffPlan = listing?.is_offplan_listing;
      const transformedSaleTypes = response?.sale_types.map((type) => ({
        ...type,
        label: tenantUtils.getLocalisedString(type, 'name'),
        key: type.id,
      }));
      return {
        listing: listing
          ? {
              ...listing,
              location: { ...listing?.location, breadcrumb: listing?.location?.breadcrumb?.reverse() },
              platform: {
                ksa: tenantTransformers.postedToBayut(listing?.status?.name),
              },
              listingPrice: { value: listing?.price, currency: tenantConstants.CURRENCY },
              isDailyRental: listing?.listing_purpose?.slug == 'daily-rental',
              residenceTypes,
              ...(isOffPlan && { saleTypes: transformedSaleTypes }),
            }
          : listing,
      };
    },
  },
  updateListing: {
    query: ({ values, listing, autoRenew, productId, source }) => {
      const payload = tenantPayloads.getUpdateListingPayload({ values, listing, autoRenew, productId, source });
      return { url: `/api/listings/${values?.id}`, method: 'PUT', body: payload };
    },
  },
};

export default postNewListingEndpoints;
